import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CourseService } from 'src/app/services/course.service';
import { CategoryService } from 'src/app/services/category.service';
import { Observable } from 'rxjs';
import { Category } from 'src/app/models/category';
import { Course } from 'src/app/models/course';
import { RoleFilters } from 'src/app/models/roleFilters';

@Component({
  selector: 'app-course-picker',
  templateUrl: './course-picker.component.html',
  styleUrls: ['./course-picker.component.scss']
})
export class CoursePickerComponent implements OnInit {
  public selectedCourse: any;
  public addError:string = null;
  public categories: Observable<Category[]>;
  public loadingCourses: boolean = false;
  public courses: Course[];

  constructor(public dialogRef: MatDialogRef<CoursePickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any, private courseService: CourseService, private categoryService: CategoryService) { 
    }

  ngOnInit() {
    this.categories=this.categoryService.getCategories();
  }

  cancel(){
    this.dialogRef.close(false);
  }

  addCourse(course){
    this.dialogRef.close(course);
  }

  submit(){

  }

  selectCategory(category_id){
    this.loadingCourses = true;
    this.categoryService.getCategoryCourses(category_id, new RoleFilters).subscribe(res=>{
      this.courses = res;
      this.loadingCourses = false;
    })
  }
}
